<template>
  <div id='navbar'>
    <router-link to='/ask' class='ask'>Frage<br>stellen</router-link>
    <router-link to='/pins' class='pins'>Meine<br>Pins</router-link>
    <router-link to='/profile' class='profile'>Meine<br>Fragen</router-link>
  </div>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>
<style scoped>
#navbar{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.pins{
  justify-self: center;
  text-align: center;
}

.ask{
  justify-self: start;
  text-align:center;
}

.profile{
  justify-self: end;
  text-align:center;
}

a{
  text-decoration: none;
  color: #2d3436;
  font-weight: bold;
  font-size: 1em;
  padding: 5px 10px 0 10px;
}
</style>
